import type { CSSProperties } from 'react';
import type { AnimatedValue, UseTransitionResult } from 'react-spring';
import { config, useSpring, useTransition } from 'react-spring';

type AccordianTransitions = [
  AnimatedValue<CSSProperties>,
  UseTransitionResult<boolean, CSSProperties>[],
];

interface AccordianOptions {
  expandedHeight: number;
  collapsedHeight: number;
}

const useAccordian = (
  collapsed: boolean,
  { expandedHeight, collapsedHeight }: AccordianOptions,
): AccordianTransitions => {
  const height = useSpring({
    config: config.stiff,
    to: { height: collapsed ? collapsedHeight : expandedHeight },
  });

  const fades = useTransition(collapsed, null, {
    config: config.stiff,
    enter: { opacity: 1 },
    leave: { position: 'absolute', opacity: 0, width: '100%' },
  });

  return [height, fades];
};

export { useAccordian };
